export const KEY_SEPARATOR = '@';

export const LIVE_SNAPSHOT_ID = 'live';

export const SNAPSHOT_ID = 'snapshotId';

export const SLEEP_TIMEOUT = 5000;

export const MAX_RETRIES = 4;

export const BASE_MS = 3000;

export const DOWNLOAD_FILE_NAME = 'Accuracy Data.xls';

export const MAX_PAYLOADS_THRESHOLD = 5;

export const TOGGLE_PLACEMENT = Object.freeze({
  IN_HEADER: 'inHeader'
});

export const OPERATION_STATUS = Object.freeze({
  NONE: 'NONE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCESS: 'SUCESS',
  FAIL: 'FAIL',
});

export const QUERY_EXECUTION_STATUS = Object.freeze({
  COMPLETE: 'COMPLETE',
});

export const PAGINATION = Object.freeze({
  SIZE: 250,
  SELECTOR: [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
    { value: 250, label: '250' },
    { value: 500, label: '500' },
  ],
});

export const TEXT = Object.freeze({
  LOADING: 'Loading ...',
  DISPLAY_IN_MILLIONS: 'Display in Millions',
  EMPTY: 'No matching data found.',
  PREFERENCES: 'Preferences',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  SELECT_BAR: 'Please click on a bar from ASIN histogram to get a list of sample ASINs.'
});

export const REPORT_KEYS = Object.freeze({
  COMPONENT: 'component',
  BASE_FACTOR: 'baseFactor',
  MARKETPLACE: 'marketplace',
});

export const PL_REPORT = Object.freeze({
  WRAP_LINE_COLUMNS: ['productGroup', 'productLineID', 'productLineName', 'parentProductLineName'],
  DEDUPED_COL_KEYS: [
    'channel',
    'marketplace',
    'component',
    'type',
    'productGroup',
    'productLineID',
    'productLineName',
    'parentProductLineName',
    'currencyCode',
  ]
});

export const FORECAST_REPORT = Object.freeze({
   WRAP_LINE_COLUMNS: ['productGroup', 'productLineID', 'productLineName', 'parentProductLineName', 'baseFactor'],
   DEDUPED_COL_KEYS: [
     'channel',
     'marketplace',
     'component',
     'type',
     'productGroup',
     'productLineID',
     'productLineName',
     'parentProductLineName',
     'currencyCode',
     'baseFactor',
   ],
  SORTABLE_COLUMNS: ['absAccuracy','absInaccuracy', 'otherVariancePercent', 'guidanceCognosAVPercent', 'otherVariance', 'fortuneGuidanceAmountCognosAV','dailyCPAmountCognosAV'],
 });

export const COMPONENT_REPORT = Object.freeze({
  WRAP_LINE_COLUMNS: ['productGroup', 'productLineName', 'parentProductLineName', 'timestamp', 'type'],
  DEDUPED_COL_KEYS: ['channel', 'component', 'type']
});

export const ACCURACY_REPORT_CONFIG = Object.freeze({
  COMPONENT: COMPONENT_REPORT,
  PL: PL_REPORT,
  FORECAST: FORECAST_REPORT,
})



// WEBPACK FOOTER //
// ./src/components/reports/common/constants.js